import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { EmployeeService } from '../service/employee.service';
import { of } from 'rxjs';

export const employeeInterceptor: HttpInterceptorFn = (req, next) => {
  const employeeService = inject(EmployeeService);
  if (!req.url.includes('employee')) {
    return next(req);
  }
  if (req.url.includes('year')) {
    const queryString = req.url.split('?')[1];
    const params = new URLSearchParams(queryString);
    const year = Number(params.get('year'));
    const data = employeeService.getEmployeesByYear(
      year,
      req.url.includes('inf'),
    );
    if (!data) {
      return next(req);
    }
    return of(new HttpResponse({ status: 200, body: data.employees }));
  }
  return next(req);
};
